
'use strict';


export default class BaptistSlider extends HTMLElement {

    constructor () {
        super();

        if ( !this.getAttribute('timer'))
            throw 'Attribute "timer" not set';

        this.interval;

        this.slides = this.querySelectorAll('.slide');

        if ( this.getAttribute('navigation') === 'true' ) {
            this.setupNavigation();
        }
        
        this.slides.forEach(slide => slide.style.transitionDuration = '0s');
        this.setCurrentSlide(0);

        window.setTimeout(
            () => this.slides.forEach(slide => slide.style.transitionDuration = ''),
            0
        );

        if ( this.getAttribute('navigation') === 'true' ) {
            window.addEventListener('resize', () => this.setButtonsTop());
        }
    }

    get currentSlide () {
        return this.querySelector('[current]');
    }

    setCurrentSlide (index) {
        if ( this.slides[index] ) {
            if ( this.currentSlide )
                this.currentSlide.removeAttribute('current');

            this.slides[index].setAttribute('current', 'step');
            this.currentSlideIndex = index;

            if ( this.getAttribute('navigation') === 'true' ) {
                this.setCurrentPagination(index);
                window.setTimeout(() => this.setButtonsTop(), 0);
            }

            clearInterval(this.interval);
            this.interval = window.setInterval(
                () => this.gotoNextSlide(),
                this.getAttribute('timer')
            );
        }
    }

    setCurrentPagination (index) {
        this.paginationButtons
            .forEach(button => button.classList.remove('current'));

        this.paginationButtons[index].classList.add('current');
    }

    gotoPrevSlide () {
        if ( this.currentSlideIndex === 0 ) {
            this.setCurrentSlide(this.slides.length - 1);
        } else {
            this.setCurrentSlide(this.currentSlideIndex - 1);
        }
    }

    gotoNextSlide () {
        if ( this.slides.length > this.currentSlideIndex + 1 ) {
            this.setCurrentSlide(this.currentSlideIndex + 1);
        } else {
            this.setCurrentSlide(0);
        }
    }

    setupNavigation () {
        this.setupPagination();
        this.setupButtons();
    }

    setupPagination () {
        this.paginationButtons = [];
        const nav = document.createElement('nav');

        for ( let i = 0; i < this.slides.length; i++ ) {
            const button = document.createElement('button');

            button.addEventListener('click', () => {
                this.setCurrentSlide(i);
            });

            nav.append(button);

            this.paginationButtons.push(button);
        }

        this.append(nav);
    }

    setupButtons () {
        const prevBtn = document.createElement('button');
        prevBtn.innerHTML = 'Vorige';
        prevBtn.classList.add('prev');
        prevBtn.addEventListener('click', () => this.gotoPrevSlide());

        const nextBtn = document.createElement('button');
        nextBtn.innerHTML = 'Volgende';
        nextBtn.classList.add('next');
        nextBtn.addEventListener('click', () => this.gotoNextSlide());

        this.append(prevBtn);
        this.append(nextBtn);

        this.buttons = [prevBtn, nextBtn];
    }

    setButtonsTop () {
        const img = this.currentSlide.querySelector('.slide-img');

        const imgHeight = img
            ? this.currentSlide
                .querySelector('.slide-img')
                .getBoundingClientRect()
                .height
            : 0;

        this.buttons.
            forEach(btn =>
                btn.style.top = imgHeight / 2 +'px'
            );
    }

}
